// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": true,
    "raw": "fbdd2dc-dirty",
    "hash": "fbdd2dc",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "fbdd2dc-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
